import axios from 'axios'

const state = {
  referralKey: null,
  projects: [],
  homeProjects: [],
  portfolioProjects: [],
  current: null,
  documents: [],
  invoices: [],
  team: []
}

const actions = {
  REQUEST_PROPOSAL ({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      data.referred_by = state.referralKey
      axios.post(process.env.VUE_APP_BASE_URL + 'api/proposal/', data)
        .then((response) => {
          // commit('SET_TOKEN', response.data.api_token.key)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  LOAD_PROJECTS ({ commit, getters }) {
    return new Promise((resolve, reject) => {
      let config = {
        headers: {
          Authorization: 'Token ' + getters.authToken
        }
      }
      axios.get(process.env.VUE_APP_BASE_URL + 'api/projects/', config)
        .then((response) => {
          commit('SET_PROJECTS', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  LOAD_PROJECT_BY_ID ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      let config = {
        headers: {
          Authorization: 'Token ' + getters.authToken
        }
      }
      axios.get(process.env.VUE_APP_BASE_URL + 'api/projects/' + id, config)
        .then((response) => {
          commit('SET_CURRENT_PROJECT', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  LOAD_HOME_PROJECTS ({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios.get(process.env.VUE_APP_BASE_URL + 'api/home/projects/')
        .then((response) => {
          commit('SET_HOME_PROJECTS', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  LOAD_PORTFOLIO_PROJECTS ({ commit, state }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(process.env.VUE_APP_BASE_URL + `api/portfolio/${userId}/`)
        .then((response) => {
          commit('SET_PORTFOLIO_PROJECTS', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  LOAD_PROJECT_DOCUMENTS ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      let config = {
        headers: {
          Authorization: 'Token ' + getters.authToken
        }
      }
      axios.get(process.env.VUE_APP_BASE_URL + 'api/projects/' + id + '/documents/', config)
        .then((response) => {
          commit('SET_DOCUMENTS', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  LOAD_PROJECT_INVOICES ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      let config = {
        headers: {
          Authorization: 'Token ' + getters.authToken
        }
      }
      axios.get(process.env.VUE_APP_BASE_URL + 'api/projects/' + id + '/invoices/', config)
        .then((response) => {
          commit('SET_INVOICES', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  LOAD_PROJECT_TEAM ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      let config = {
        headers: {
          Authorization: 'Token ' + getters.authToken
        }
      }
      axios.get(process.env.VUE_APP_BASE_URL + 'api/projects/' + id + '/team/', config)
        .then((response) => {
          commit('SET_TEAM', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  }
}

const getters = {
  getProjects: state => {
    return state.projects
  }
}

const mutations = {
  SET_PROJECTS (state, payload) {
    state.projects = payload
  },
  SET_HOME_PROJECTS (state, payload) {
    state.homeProjects = payload
  },
  SET_PORTFOLIO_PROJECTS (state, payload) {
    state.portfolioProjects = payload
  },
  SET_CURRENT_PROJECT (state, payload) {
    state.current = payload
  },
  SET_DOCUMENTS (state, payload) {
    state.documents = payload
  },
  SET_INVOICES (state, payload) {
    state.invoices = payload
  },
  SET_TEAM (state, payload) {
    state.team = payload
  },
  SET_REFERRAL_KEY (state, payload) {
    state.referralKey = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
